<template>
  <p
    v-if="text && title"
    class="consumer-ratings"
    data-test-id="consumer-ratings"
  >
    <!-- eslint-disable vue/multiline-html-element-content-newline -->
    <ELink
      v-if="title && url"
      :href="url"
      :target="linkTarget"
      color="dark"
      data-test-id="consumer-ratings-link"
    >{{ title }}</ELink><span v-else>{{ title }}</span><span data-test-id="consumer-ratings-content">: {{ text }}</span>
    <!-- eslint-enable vue/multiline-html-element-content-newline -->
  </p>
</template>

<script>
import { mapGetters } from 'vuex';
import ELink from '~~/common/vue/components/link';

export default {
  components: {
    ELink,
  },
  props: {
    url: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapGetters('user', ['linkTarget']),
  },
};
</script>

<style lang="scss" scoped>
.consumer-ratings {
  @extend %ellipsis;

  margin: 0;
}
</style>
